import React from "react";
import integrationsData from "../api/data/integrations-data";
import IntegrationTemplate from "../../components/IntegrationTemplate";

const IntegrationPages: React.FC<{ data: any }> = (props) => {
    const integrationData = props.data;
    return <IntegrationTemplate integrationData={integrationData} />;
};
export default IntegrationPages;
export async function getStaticProps({ params }: { params: any }): Promise<Record<string, any> | string> {
    const slug = params.slug;
    return {
        props: {
            data: integrationsData[slug],
        },
    };
}

export async function getStaticPaths(): Promise<{
    paths: string[];
    fallback: boolean;
}> {
    const data = Object.keys(integrationsData);
    const paths = data.map((ele) => `/whatsapp-integrations/${ele}`);
    return {
        paths: paths,
        fallback: false,
    };
}
